/*
 * Pinned product story: while the section is pinned, scroll progress swaps three photo layers (each wipes up over the
 * last using transforms only) and three captions take turns. Static stack for reduced motion / no script.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ex-story]');
  if (!root || !window.EluxaScroll || window.EluxaScroll.reduced()) return;

  var figs = [].slice.call(root.querySelectorAll('.ex-st__fig'));
  var steps = [].slice.call(root.querySelectorAll('.ex-st__step'));
  var imgs = figs.map(function (f) { return f.querySelector('.ex-st__img'); });
  var chips = figs.map(function (f) { return f.querySelector('.ex-st__chip'); });
  var bars = [].slice.call(root.querySelectorAll('.ex-st__bars i'));
  var cta = root.querySelector('.ex-st__cta');
  if (figs.length < 2 || figs.length !== steps.length) return;
  root.classList.add('is-anim');

  var n = figs.length;
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  function render(p) {
    // a[k]: 0 -> 1 while moving from step k to step k+1 (transition windows sit between the steps)
    var seg = 1 / n, a = [], i;
    for (i = 0; i < n - 1; i++) a.push(ease(clamp((p - (i + 1) * seg + seg * 0.2) / (seg * 0.4))));
    for (i = 0; i < n; i++) {
      // caption leaves in the first half of a transition and the next one arrives in the second half
      var inn = i === 0 ? 1 : clamp(a[i - 1] * 2 - 1);
      var out = i === n - 1 ? 0 : clamp(a[i] * 2);
      var op = inn * (1 - out);
      steps[i].style.opacity = op.toFixed(3);
      steps[i].style.transform = 'translate3d(0,' + (((1 - inn) * 44) - out * 44).toFixed(1) + 'px,0)';
      if (i > 0) {
        var r = 1 - a[i - 1];
        figs[i].style.transform = 'translate3d(0,' + (r * 100).toFixed(2) + '%,0)';
        imgs[i].style.transform = 'translate3d(0,' + (-r * 100).toFixed(2) + '%,0) scale(' + (1 + 0.1 * r).toFixed(3) + ')';
        if (chips[i]) chips[i].style.opacity = (1 - r) < 0.4 ? '0' : ((1 - r - 0.4) / 0.6).toFixed(3);
      }
      if (bars[i]) bars[i].style.setProperty('--f', clamp(p * n - i).toFixed(3));
    }
    if (cta) cta.style.opacity = (a[n - 2] > 0.6 ? clamp((p - (1 - seg * 0.28)) / (seg * 0.22)) : 0).toFixed(3);
  }

  // Layers 2 and 3 are clipped away until their wipe starts, so the browser's lazy loading would not fetch them in
  // time. Keep every image lazy, but load them all as soon as the section is one screen away.
  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      near.disconnect();
      imgs.forEach(function (im) { if (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); } });
    }, { rootMargin: '100% 0px' });
    near.observe(root);
  } else {
    imgs.forEach(function (im) { if (im) im.loading = 'eager'; });
  }

  window.EluxaScroll.pin(root, render);
})();
